import { render, staticRenderFns } from "./fabiconpopover_component.vue?vue&type=template&id=de179b6e&scoped=true&"
import script from "./fabiconpopover_component.vue?vue&type=script&lang=js&"
export * from "./fabiconpopover_component.vue?vue&type=script&lang=js&"
import style0 from "./fabiconpopover_component.vue?vue&type=style&index=0&id=de179b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de179b6e",
  null
  
)

export default component.exports